const actions = [
  {
      title: 'Identify the behaviour you would like to start or stop.',
      text: 'Take a minute to think about the behaviour you are trying to change. Try to be really specific, [e.g. \'I am going to take a multivitamin supplement every morning\']. Write this down.',
  },
  {
      title: 'Decide when and where you will carry out this action.',
      text: 'Write down the specific scenario in which you will carry out this behaviour. [ E.g. I will take the vitamin supplement when I am having my breakfast.]',
  },
  {
      title: 'Identify what could serve as a useful prompt.',
      text: 'Have a think about what prompt or \'reminder\' you might need to help you. This could be anything from a reminder on your phone, to placing the supplements on top of your usual morning coffee mug. Don\'t be afraid to get a bit creative!',
  },
  {
      title: 'Create a reminder for yourself.',
      text: 'Add your reminder into your environment. This is where you\'ll add your reminder to your chosen place, e.g. creating the reminder on your phone.',
  },
];

const tip = 'Don\'t be afraid to get creative with your reminders, even if it feels a bit silly! Think carefully about your usual routines, and where you could add in gentle reminders for yourself.';

// eslint-disable-next-line import/no-anonymous-default-export
export default { actions, tip };
